import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { InspectionStore } from '../stores/inspectionStore';

interface InspectionsContext {
  inspectionStore: InspectionStore;
}

const useInspectionStore = () => useContext<InspectionsContext>(StoreContext);

export default useInspectionStore;
